/**
 * BudgetSetupCard Component - Trip budget setup form
 */
import React, { useState } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';

const BudgetSetupCard = ({ isDarkMode, settings, onSave, onCancel }) => {
  const { t } = useTranslation();
  const [totalBudget, setTotalBudget] = useState(settings.total_budget || '');
  const [tripDays, setTripDays] = useState(settings.trip_days || 7);
  
  const dailyBudget = totalBudget && tripDays ? (parseFloat(totalBudget) / tripDays).toFixed(0) : 0;
  
  return (
    <div className={`p-4 rounded-xl ${isDarkMode ? 'bg-gradient-to-br from-purple-900/50 to-pink-900/50' : 'bg-gradient-to-br from-purple-100 to-pink-100'}`}>
      <h4 className={`font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
        🎯 {t('set_trip_budget')}
      </h4>
      <p className={`text-sm mb-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
        {t('budget_auto_calculate')}
      </p>
      
      <div className="space-y-3">
        <div>
          <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            {t('total_trip_budget')}
          </label>
          <input
            type="number"
            placeholder="e.g., 5000"
            value={totalBudget}
            onChange={(e) => setTotalBudget(e.target.value)}
            className={`w-full px-3 py-2.5 rounded-lg text-lg font-medium ${isDarkMode ? 'bg-gray-700 text-white' : 'bg-white border'}`}
          />
        </div>
        
        <div>
          <label className={`block text-xs mb-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            {t('trip_duration')}
          </label>
          <input
            type="number"
            min="1"
            value={tripDays}
            onChange={(e) => setTripDays(parseInt(e.target.value) || 1)}
            className={`w-full px-3 py-2.5 rounded-lg ${isDarkMode ? 'bg-gray-700 text-white' : 'bg-white border'}`}
          />
        </div>
        
        {totalBudget > 0 && (
          <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-gray-700' : 'bg-white'}`}>
            <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{t('daily_budget')}</p>
            <p className={`text-2xl font-bold ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>
              {dailyBudget} {t('dh_per_day')}
            </p>
          </div>
        )}
        
        <div className="flex gap-2">
          <button
            onClick={() => onSave(parseFloat(totalBudget), tripDays)}
            disabled={!totalBudget || totalBudget <= 0}
            className="flex-1 py-2.5 bg-green-500 text-white rounded-lg font-medium hover:bg-green-600 disabled:opacity-50"
          >
            ✓ {t('save_budget')}
          </button>
          {settings.total_budget > 0 && (
            <button
              onClick={onCancel}
              className={`px-4 py-2.5 rounded-lg ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-200 hover:bg-gray-300'}`}
            >
              {t('cancel')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default BudgetSetupCard;
